<template>
  <OrgPersonMgr />
</template>

<script>
export default {
    data() {
        return {
        }
    }
}
</script>
